import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { InfoCircle } from 'react-bootstrap-icons';
import { useFormContext } from 'react-hook-form';

import { getComponentFormError } from '../../../utils';

import './style.scss';

interface Props {
  label: string;
  name: string;
  defaultValue?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  onChange?: any;
  description?: string;
}

function Check(props: Props) {
  const methods = useFormContext();
  const { label, description, name, defaultValue, disabled, readOnly, onChange } = props;
  const {
    register,
    formState: { errors }
  } = methods;
  const error = getComponentFormError(name, errors);

  const { onChange: registerOnChange, ...registerProps } = register(name);

  return (
    <Form.Group>
      <Form.Label>
        {label}{' '}
        {description ? (
          <OverlayTrigger overlay={<Tooltip id={`tooltip-${name}`}>{description}</Tooltip>}>
            <span className="d-inline-block">
              <InfoCircle className="small"></InfoCircle>
            </span>
          </OverlayTrigger>
        ) : (
          <></>
        )}
      </Form.Label>

      <div>
        <label htmlFor="{{ name }}"></label>
        <label className="switch">
          <input
            {...registerProps}
            type="checkbox"
            name={name}
            defaultChecked={defaultValue}
            disabled={disabled}
            readOnly={readOnly}
            className=" primary"
            onChange={(e: any) => {
              registerOnChange(e);
              if (onChange) {
                onChange(e.target.checked);
              }
            }}
          />
          <span className="slider round" />
        </label>
      </div>

      <div className="invalid-feedback d-block">{error ? error.message : ''}</div>
    </Form.Group>
  );
}

export default Check;
